// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"nn","contentFrame":"no","button":"np","header":"nq","text":"nr","contentImage":"ns"};